<router-outlet></router-outlet>
<script src="assets/js/slider-clip.js"></script>
<ngx-spinner size="default" name="s1" type="ball-scale-multiple"></ngx-spinner>
<!-- İnşallah, aşağıdaki kod spinner için kullanılmıştır. -->
<ngx-spinner name="s2"
  bdcolor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-newton-cradle"
>
  <!-- İnşallah, aşağıdaki kod spinner için kullanılmıştır. -->
  <p class="text-white text-lg">loading...</p>
</ngx-spinner>

<ngx-spinner name="sbar"
  bdcolor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-newton-cradle"
>
  <p class="text-white text-lg">QR kodu Okunyor...</p>
</ngx-spinner>
<ngx-spinner size="default" name="s3" type="ball-atom"></ngx-spinner>
<ngx-spinner size="default" name="s4" type="ball-pulse"></ngx-spinner>
